// src/pages/About.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../hooks/useLanguage';
import './About.css'; // Import the CSS file
import { UserContext } from '../../context/UserContext';

const About_en = () => {
  const { user } = useContext(UserContext);
  const lang = useLanguage();

  return (
    <>
      <title>About SeegSoog | Smart Off-Market US Real Estate Investing</title>
      <div className="about-container">
        <div className="about-content">
          <h1>About SeegSoog.com</h1>
          <p>
            SeegSoog.com is a marketplace built to make smarter, faster real estate investment decisions in the U.S. off‑market space. It brings motivated sellers and serious investors together, standardizes the numbers that matter, and adds AI‑powered
            analysis so every deal can be evaluated on equal footing.
          </p>

          <h2>Why it exists</h2>
          <p>
            SeegSoog started from a simple frustration: reaching the right sellers was slow, comparing deals on consistent parameters was messy, and analyzing proposals was complicated, difficult, andtook too long. This platform was created to fix that by
            centralizing outreach, aligning metrics, and automating the heavy analysis so focus stays on return and risk.
          </p>

          <h2>What it offers</h2>
          <ul>
            <li>Multiple investment offers in one place.</li>
            <li>Matching between the user investment profile and the property.</li>
            <li>Standardized financial metrics for apples‑to‑apples comparison across markets and property types.</li>
            <li>On‑demand, AI‑assisted reports that surface key metrics, trends, sensitivities, and red flags.</li>
          </ul>

          <h2>Our approach</h2>
          <p>
            Transparency, integrity, and speed guide every feature—from clear inputs and methodology to streamlined messaging and decision workflows. The goal is straightforward: help investors act confidently while giving sellers a professional path to
            serious buyers.
          </p>

          <p>
            <Link to={`/${lang}/map`}>Explore current opportunities</Link>, learn how the tools work, or <Link to={`/${lang}/contact-us`}>get in touch</Link> to share feedback and shape what comes next.
          </p>
          {user.isLoggedIn && user.isAdmin && <p className="admin-message">You are logged in as an administrator.</p>}
          <p>SeegSoog.com is operated by Log-Inn the Smart Home Ltd, Company Registeration Number 514147305, Israel</p>
        </div>
      </div>
    </>
  );
};

export default About_en;
